export const BASE_URL = "https://educapture-backend-flask.onrender.com";
